<app-particles></app-particles>

<main>
  <div class="container-xl">
      <router-outlet></router-outlet>
  </div>
</main>

<app-footer [language]="loc.language"></app-footer>
